export default __webpack_public_path__ + "static/media/p1.0384c437.jpg";